/** Staff users manage shared food groups only; org listing requires dietitian role. */
export const shouldSkipOrgFoodGroupsQuery = (isStaff?: boolean): boolean => Boolean(isStaff);
